/* ============================================================
   Loopy Lamp-produktside (lo26) — klient-adfærd
   Kører OVEN PÅ temaets eksisterende motorer og erstatter dem ikke:
     - Kropsfarven er temaets NORMALE variant-picker (color-swatches
       type:'detail' → variant-radios-detail). Klik, pris, lager og URL
       hører helt til theme.js.
     - Sticky-baren er temaets <pd-sticky-bar> (main-product.js).
   Det eneste rigtigt nye er kurv-kaldet: figuren OG den valgte lyskilde
   lægges i kurven som TO linjer i ét POST /cart/add.js — samme mønster som
   lpAddToCart i assets/ladeport-v2.js (som spejler theme.js' addItemsToCart).
   Se docs/LOOPY_PRODUKTSIDE_2026_09.md.
   ============================================================ */
(function () {
  'use strict';

  var section = document.querySelector('.product-loopy-section');
  if (!section) return;

  var sectionId = section.getAttribute('data-section');
  var mainForm = section.querySelector('form[id^="product-form-"]');
  var stickyForm = document.getElementById('sticky-addcart-form-' + sectionId);
  var stickyEl = section.querySelector('pd-sticky-bar');

  /* ── Hjælpere ── */
  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt =
        (window.themeGlobalVariables &&
          window.themeGlobalVariables.settings &&
          window.themeGlobalVariables.settings.money_format) ||
        (window.cartStrings && window.cartStrings.money_format);
      if (fmt) return window.Shopify.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }

  var productData = null;
  function getProduct() {
    if (productData) return productData;
    var el = section.querySelector('.productJson, [data-product-json]');
    if (!el) return null;
    try {
      productData = JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
    return productData;
  }

  function currentVariantId() {
    var input = mainForm && mainForm.querySelector('input[name="id"]');
    var id = input ? parseInt(input.value, 10) : NaN;
    if (!isNaN(id)) return id;
    var data = getProduct();
    if (data && data.variants && data.variants.length) return data.variants[0].id;
    return null;
  }

  function currentVariant() {
    var data = getProduct();
    var id = currentVariantId();
    if (!data || !data.variants || !id) return null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === id) return data.variants[i];
    }
    return null;
  }

  function currentQty() {
    var input = section.querySelector('quantity-input input[name="quantity"]');
    var v = input ? parseInt(input.value, 10) : 1;
    if (isNaN(v) || v < 1) v = 1;
    return Math.min(v, 99);
  }

  /* ── 1) Hero-video: hentes først når den er i syne ──
     Posteren bærer LCP'en. Videoen springes helt over ved
     prefers-reduced-motion, Save-Data og på mobil når section-settingen
     "Afspil hero-video på mobil" er slået fra — så koster den 0 bytes. */
  (function initHeroVideo() {
    var video = section.querySelector('[data-lo-video]');
    if (!video) return;

    var src = video.getAttribute('data-src');
    if (!src) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    var allowMobile = section.getAttribute('data-lo-hero-video-mobile') === '1';
    var isNarrow = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

    if (reduced || saveData || (isNarrow && !allowMobile)) return;

    var started = false;
    function start() {
      if (started) return;
      started = true;
      video.setAttribute('src', src);
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.addEventListener(
        'canplay',
        function () {
          video.classList.add('is-playing');
        },
        { once: true }
      );
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    var hero = section.querySelector('.lo26-hero');
    if (hero && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              start();
              io.disconnect();
            }
          });
        },
        { threshold: 0.1 }
      );
      io.observe(hero);
    } else {
      start();
    }
  })();

  /* ── 2) Lys-tilvalget ──
     Én tilstand deles af købskortets trin, den mørke bane og sticky-baren.
     "extra" er variantens pris minus den billigste variants pris, altså
     præcis det kunden betaler oveni (den inkluderede udgave gøres gratis
     af en automatisk rabat i Shopify). */
  var addonButtons = section.querySelectorAll('[data-lo-addon-variant]');
  var addonState = { id: null, extra: 0 };

  function syncAddons() {
    addonButtons.forEach(function (btn) {
      var isOn = parseInt(btn.getAttribute('data-lo-addon-variant'), 10) === addonState.id;
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      var state = btn.querySelector('[data-lo-addon-state]');
      if (state) {
        state.textContent = isOn
          ? state.getAttribute('data-lo-label-on') || 'Valgt'
          : state.getAttribute('data-lo-label-off') || 'Vælg';
      }
    });
  }

  function setAddon(id, extra) {
    addonState.id = id;
    addonState.extra = extra;
    syncAddons();
    updateTotals();
  }

  if (addonButtons.length) {
    /* Standardvalg = den inkluderede (billigste) udgave. */
    var cheapest = null;
    addonButtons.forEach(function (btn) {
      var extra = parseInt(btn.getAttribute('data-lo-addon-extra'), 10) || 0;
      if (cheapest === null || extra < cheapest.extra) {
        cheapest = { id: parseInt(btn.getAttribute('data-lo-addon-variant'), 10), extra: extra };
      }
      btn.addEventListener('click', function () {
        setAddon(
          parseInt(btn.getAttribute('data-lo-addon-variant'), 10),
          parseInt(btn.getAttribute('data-lo-addon-extra'), 10) || 0
        );
      });
    });
    if (cheapest) {
      addonState.id = cheapest.id;
      addonState.extra = cheapest.extra;
    }
    syncAddons();
  }

  /* ── 3) Totaler i knapperne ──
     Temaet skriver figurens pris i .btn-price ved hvert variantskift; vi
     lægger lys-merprisen oveni. Skrivningen gentages kun når teksten rent
     faktisk afviger, så MutationObserveren ikke kan løbe løbsk. */
  function totalCents() {
    var v = currentVariant();
    var base = v ? v.price : 0;
    return (base + addonState.extra) * currentQty();
  }

  function updateTotals() {
    var str = money(totalCents());

    var btnPrice = section.querySelector('.product-form__submit .btn-price');
    if (btnPrice && btnPrice.textContent.trim() !== str) {
      btnPrice.textContent = str;
    }

    if (stickyEl) {
      var stickyText = stickyEl.querySelector('.pd-sticky__btn-text');
      var stickyBtn = stickyEl.querySelector('.pd-sticky__btn');
      if (stickyText && stickyBtn && !stickyBtn.disabled) {
        var label = (stickyBtn.getAttribute('data-lo-label') || 'Læg i kurv') + ' · ' + str;
        if (stickyText.textContent.trim() !== label) stickyText.textContent = label;
      }
    }
  }

  if (stickyEl) {
    var sBtn = stickyEl.querySelector('.pd-sticky__btn');
    var sTxt = stickyEl.querySelector('.pd-sticky__btn-text');
    if (sBtn && sTxt) sBtn.setAttribute('data-lo-label', sTxt.textContent.trim());
  }

  /* ── 4) "Dit valg" + trin-værdien følger den valgte swatch ── */
  function syncSelection() {
    var picker = section.querySelector('variant-radios-detail, variant-group-detail');
    if (!picker) return;
    var checked = picker.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    var label = picker.querySelector('label[for="' + checked.id + '"]');
    var value = checked.value || (label && label.getAttribute('data-value')) || '';

    section.querySelectorAll('[data-lo-sum-name]').forEach(function (el) {
      el.textContent = value;
    });

    var swatch = label ? label.getAttribute('data-option-swatch-value') : '';
    var dot = section.querySelector('[data-lo-sum-dot]');
    if (dot && swatch) {
      if (/^url\(/i.test(swatch)) {
        dot.style.backgroundImage = swatch;
        dot.style.backgroundSize = 'cover';
      } else {
        dot.style.background = swatch;
      }
    }
  }

  /* ── 5) Leveringsdatoen i sticky-baren ──
     Server-renderet med sin egen korte tekst ("Leveres 21. sep") og SAMME
     cutoff-indstillinger som købskortets badge — begge kommer fra price-
     blokken, så de to datoer ikke kan løbe fra hinanden. Intet at gøre her;
     faldbacket nedenfor dækker kun det tilfælde hvor baren står tom. */
  function syncStickyDelivery() {
    var target = section.querySelector('[data-lo-sticky-deliv]');
    if (!target || target.textContent.trim() !== '') return;
    var badge = section.querySelector('.lo26-deliv .pf-delivery-badge');
    if (badge) target.textContent = (badge.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* ── 6) Sticky-bar: antal spejles til hovedformularen ── */
  (function initStickyQty() {
    if (!stickyEl) return;
    var mainQty = section.querySelector('quantity-input input[name="quantity"]');
    var stickyQtyInput = stickyEl.querySelector('[data-pv26-sticky-quantity]');
    var stickyQtyValue = stickyEl.querySelector('[data-pv26-qty-value]');
    var minusBtn = stickyEl.querySelector('[data-pv26-qty-minus]');
    var plusBtn = stickyEl.querySelector('[data-pv26-qty-plus]');

    function setQty(q) {
      q = Math.max(1, Math.min(99, q));
      if (mainQty) {
        mainQty.value = String(q);
        mainQty.dispatchEvent(new Event('input', { bubbles: true }));
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (stickyQtyInput) stickyQtyInput.value = String(q);
      if (stickyQtyValue) stickyQtyValue.textContent = String(q);
      updateTotals();
    }

    if (minusBtn) minusBtn.addEventListener('click', function () { setQty(currentQty() - 1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { setQty(currentQty() + 1); });

    if (mainQty) {
      ['input', 'change'].forEach(function (evt) {
        mainQty.addEventListener(evt, function () {
          var q = currentQty();
          if (stickyQtyInput) stickyQtyInput.value = String(q);
          if (stickyQtyValue) stickyQtyValue.textContent = String(q);
          updateTotals();
        });
      });
    }
  })();

  /* ── 7) Sticky-bar reveal ──
     To uafhængige mekanismer med vilje: IntersectionObserver er den præcise,
     scroll-lytteren er garantien. lc26's bar hang på ét signal og kom aldrig
     frem (docs/LYSKAEDE_PRODUKTSIDE_2026_09_05.md). show() afviser
     gentagelser, så de to ikke kan slås indbyrdes. */
  (function initStickyReveal() {
    var anchor = section.querySelector('[data-lo-buycard]');
    if (!stickyEl || !anchor) return;

    var current = null;
    function show(v) {
      if (v === current) return;
      current = v;
      stickyEl.classList.toggle('lo26-sticky-visible', v);
    }

    function evaluate() {
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!vh) return;
      var r = anchor.getBoundingClientRect();
      show(r.bottom <= 0 || r.top >= vh);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) { show(!e.isIntersecting); });
        },
        { threshold: 0 }
      ).observe(anchor);
    }

    var last = 0;
    function onScroll() {
      var now = Date.now();
      if (now - last < 100) return;
      last = now;
      evaluate();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    evaluate();
  })();

  /* ── 8) Kurv: figuren + den valgte lyskilde som TO linjer ──
     Begge formularer (købskortet og sticky-baren) fanges i capture-fasen,
     før temaets egne submit-handlere (product-form og PdStickyBar) når at
     køre — samme greb som assets/family-color-selector.js bruger til sin
     validering. */
  function addToCart(trigger) {
    var variantId = currentVariantId();
    if (!variantId) return;

    var items = [{ id: variantId, quantity: currentQty(), properties: headProperties() }];
    if (addonState.id) items.push({ id: addonState.id, quantity: currentQty() });

    /* Hovedets form + farve ligger på figurens linje (trin "Hoved").
       Uden head_picker-blok er objektet tomt og fjernes fra payloaden. */
    if (!Object.keys(items[0].properties).length) delete items[0].properties;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    if (trigger) trigger.classList.add('loading');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status || res.errors) throw new Error(res.description || res.message || 'cart');
        updateCartCount();
        if (cart) {
          cart.getSectionsToRender().forEach(function (s) {
            var target = document.getElementById(s.id);
            var html = res.sections && res.sections[s.id];
            if (!target || !html) return;
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var inner = parsed.querySelector('#minicart-form');
            if (inner) target.innerHTML = inner.innerHTML;
          });
          if (typeof cart.cartAction === 'function') cart.cartAction();
          cart.open();
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        /* Falder tilbage til den almindelige formular-post, så kunden
           aldrig står med en knap der intet gør. */
        if (mainForm) mainForm.submit();
      })
      .then(function () {
        if (trigger) trigger.classList.remove('loading');
      });
  }

  function updateCartCount() {
    fetch('/cart.json')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (c.item_count === undefined) return;
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.innerHTML = el.classList.contains('cart-count-drawer')
            ? '(' + c.item_count + ')'
            : c.item_count > 100 ? '~' : c.item_count;
        });
        var total = document.querySelector('header-total-price');
        if (total && typeof total.updateTotal === 'function') total.updateTotal(c);
        var ship = document.querySelector('free-ship-progress-bar');
        if (ship && typeof ship.init === 'function') ship.init(c.items_subtotal_price);
      })
      .catch(function () {});
  }

  function interceptForm(form) {
    if (!form) return;
    form.addEventListener(
      'submit',
      function (e) {
        if (!addonState.id) return; /* intet tilvalg — lad temaet klare det */
        e.preventDefault();
        e.stopImmediatePropagation();
        addToCart(form.querySelector('[type="submit"]'));
      },
      true
    );
  }

  interceptForm(mainForm);

  /* Sticky-knappen: "Automatisk" = læg i kurv på desktop, hop til købskortet
     på mobil (baren har ikke plads til farvevalget der — designets egen
     begrundelse). */
  if (stickyForm && stickyEl) {
    stickyForm.addEventListener(
      'submit',
      function (e) {
        var mode = stickyEl.getAttribute('data-lo-sticky-cta') || 'auto';
        var isNarrow = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
        var shouldScroll = mode === 'scroll' || (mode === 'auto' && isNarrow);

        if (shouldScroll) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var card = section.querySelector('[data-lo-buycard]');
          if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (!addonState.id) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        addToCart(stickyForm.querySelector('[type="submit"]'));
      },
      true
    );
  }

  /* ── 9) Hoved: form + farve som linje-egenskaber ──
     Radioerne har form="product-form-…", så temaets egen submit og
     no-JS-posten får dem med automatisk. Sticky-baren er en anden formular,
     så den får skjulte spejl-felter, der holdes i sync her. */
  function headInputs() {
    return {
      type: section.querySelector('[data-lo-head-type]:checked'),
      color: section.querySelector('[data-lo-head-color]:checked')
    };
  }

  function propKey(input) {
    var m = /^properties\[(.*)\]$/.exec(input.name || '');
    return m ? m[1] : '';
  }

  function headProperties() {
    var props = {};
    var h = headInputs();
    [h.type, h.color].forEach(function (input) {
      if (!input) return;
      var key = propKey(input);
      if (key) props[key] = input.value;
    });
    return props;
  }

  /* Kombinationer fra hoved-produktet: [form, farve, tilgængelig].
     Farver der ikke findes (eller er udsolgt) til den valgte form slås fra. */
  var headCombos = null;
  (function () {
    var el = section.querySelector('[data-lo-head-combos]');
    if (!el) return;
    try { headCombos = JSON.parse(el.textContent); } catch (e) { headCombos = null; }
  })();

  function syncHeadAvailability() {
    if (!headCombos) return;
    var type = section.querySelector('[data-lo-head-type]:checked');
    if (!type) return;
    var colors = section.querySelectorAll('[data-lo-head-color]');
    var firstOk = null;
    colors.forEach(function (input) {
      var ok = headCombos.some(function (c) {
        return c[0] === type.value && c[1] === input.value && c[2];
      });
      input.disabled = !ok;
      input.closest('.lo26-headcolor').classList.toggle('is-unavailable', !ok);
      if (ok && !firstOk) firstOk = input;
    });
    var checked = section.querySelector('[data-lo-head-color]:checked');
    if ((!checked || checked.disabled) && firstOk) firstOk.checked = true;
  }

  function syncHead() {
    if (!section.querySelector('[data-lo-head]')) return;
    syncHeadAvailability();
    var h = headInputs();
    var parts = [];
    if (h.type) parts.push(h.type.value);
    if (h.color) parts.push(h.color.value);
    var text = parts.join(' · ');
    section.querySelectorAll('[data-lo-head-value]').forEach(function (el) {
      el.textContent = text;
    });

    var dot = section.querySelector('[data-lo-head-dot]');
    if (dot && h.color) dot.style.background = h.color.getAttribute('data-swatch') || '';

    if (stickyForm) {
      [['type', h.type], ['color', h.color]].forEach(function (pair) {
        var input = pair[1];
        var mirror = stickyForm.querySelector('[data-lo-head-mirror="' + pair[0] + '"]');
        if (!input) {
          if (mirror) mirror.parentNode.removeChild(mirror);
          return;
        }
        if (!mirror) {
          mirror = document.createElement('input');
          mirror.type = 'hidden';
          mirror.setAttribute('data-lo-head-mirror', pair[0]);
          stickyForm.appendChild(mirror);
        }
        mirror.name = input.name;
        mirror.value = input.value;
      });
    }
  }

  /* ── 9b) Trinnene som harmonika: kun ét trin åbent ad gangen ──
     Krop → Hoved → Lys. Når kunden har valgt i et trin, lukker det og det
     næste åbner. Et lukket trin viser kun sin overskrift + det valgte og kan
     klikkes op igen. Uden JS står alle trin åbne (progressiv forbedring).
     Kun rigtige klik (isTrusted) flytter videre — temaets egne syntetiske
     change-events ved gen-rendering må ikke hoppe trin. */
  var buycard = section.querySelector('[data-lo-buycard]');
  var accSteps = buycard
    ? Array.prototype.filter.call(buycard.querySelectorAll('.lo26-step'), function (st) {
        return !!st.querySelector('.lo26-step__head');
      })
    : [];

  function openStep(step) {
    accSteps.forEach(function (st) {
      var on = st === step;
      st.classList.toggle('is-open', on);
      var head = st.querySelector('.lo26-step__head');
      if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  function nextStep(step) {
    var i = accSteps.indexOf(step);
    openStep(i > -1 && i < accSteps.length - 1 ? accSteps[i + 1] : null);
  }

  function syncAddonStepValue() {
    accSteps.forEach(function (st) {
      if (!st.querySelector('[data-lo-addon-variant]')) return;
      var head = st.querySelector('.lo26-step__head');
      var val = head.querySelector('[data-lo-addon-value]');
      if (!val) {
        val = document.createElement('span');
        val.className = 'lo26-step__value';
        val.setAttribute('data-lo-addon-value', '');
        head.appendChild(val);
      }
      var on = st.querySelector('[data-lo-addon-variant][aria-pressed="true"] .lo26-addon__name');
      val.textContent = on ? on.textContent : '';
    });
  }

  if (accSteps.length > 1) {
    buycard.classList.add('lo26-acc');
    accSteps.forEach(function (st) {
      var head = st.querySelector('.lo26-step__head');
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.addEventListener('click', function () {
        openStep(st.classList.contains('is-open') ? null : st);
      });
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          head.click();
        }
      });

      if (st.querySelector('[data-lo-head]') || st.hasAttribute('data-lo-head')) {
        /* Hoved: videre først når farven er valgt (formen alene er halvt). */
        st.addEventListener('change', function (e) {
          if (e.isTrusted && e.target.matches('[data-lo-head-color]')) nextStep(st);
        });
      } else if (st.querySelector('[data-lo-addon-variant]')) {
        st.addEventListener('click', function (e) {
          if (e.isTrusted && e.target.closest('[data-lo-addon-variant]')) {
            syncAddonStepValue();
            nextStep(st);
          }
        });
      } else {
        /* Krop (temaets variant-picker): videre ved et rigtigt valg. */
        st.addEventListener('change', function (e) {
          if (e.isTrusted && e.target.matches('input[type="radio"]')) nextStep(st);
        });
      }
    });
    syncAddonStepValue();
    openStep(accSteps[0]);
  }

  /* ── 10) Hold alt i sync ved variantskift ── */
  function refresh() {
    syncHead();
    syncSelection();
    syncStickyDelivery();
    updateTotals();
  }

  section.addEventListener('change', refresh);
  document.addEventListener('variant-change', refresh);

  if (mainForm) {
    var obs = new MutationObserver(function () { updateTotals(); });
    obs.observe(mainForm, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  setTimeout(refresh, 600);
})();
